export default __webpack_public_path__ + "static/media/maze4.a48c8780.png";